import { render, staticRenderFns } from "./FunnelCategoryList.vue?vue&type=template&id=f508c430"
import script from "./FunnelCategoryList.vue?vue&type=script&lang=js"
export * from "./FunnelCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports